const toPositiveEntityScope = (entity) => {
  const entityId = Number(entity?.entityId);
  return Number.isInteger(entityId) && entityId > 0 ? { entityId } : null;
};

/**
 * Keep three independent provenance decisions explicit:
 * - personal scope requires the selected actual-capable membership;
 * - settings scope requires only a concrete readable selection;
 * - user-global transport prefers the selected membership, then falls back to
 *   the first actual-capable membership from the authenticated projection.
 */
export const derivePreferenceScopes = (currentEntity, entities = []) => {
  const selectedConcreteScope = toPositiveEntityScope(currentEntity);
  const selectedPreferenceScope = (
    currentEntity?.canEditUserEntityPreferences === true
  ) ? selectedConcreteScope : null;
  const firstActualMembership = entities.find(entity => (
    entity.hasActiveMembership === true &&
    entity.canEditUserEntityPreferences === true &&
    toPositiveEntityScope(entity) !== null
  ));

  return {
    preferenceScope: selectedPreferenceScope,
    settingsScope: selectedConcreteScope,
    globalPreferenceCarrierScope: (
      selectedPreferenceScope ||
      toPositiveEntityScope(firstActualMembership)
    )
  };
};
